module.exports = __webpack_public_path__ + "img/nosearch-scfp-dat.2d2bbbba.svg";